import React from 'react';
import './ChangePassWordComponent.scss'

class ChangePassWordComponent extends React.Component{
	state = {
		imgBgLoad: false
	}

	imgLoad = (e) => {
		let name = e.target.name
		this.setState({
			[name]: true
		})
	}

	close = () => {
		this.props.close && this.props.close.onClose()
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const loginClose = require('../../asstes/img/alert/login-close.png')
		const requestImg = require('../../asstes/img/other/password-list.png')
		const beansImg = require('../../asstes/img/other/beans-receive.jpg')
		const {imgBgLoad} = this.state
		const isBeans = this.props.type === 'beans'

		return <div className="change-password-container">
			<p className="prompt"></p>
			<div className="change-password-relative">
				<img className="change-password-img" name={'imgBgLoad'} onLoad={this.imgLoad} src={loginBg} alt=""/>
				{
					!imgBgLoad ? null : <>
						<div className="change-password-container-content">
							<div className="change-password-div">
								{
									isBeans ?
										<img className="change-password-img" src={beansImg} alt=""/> :
										<img className="change-password-img" src={requestImg} alt=""/>
								}
							</div>
						</div>
						<img className="bottom-login-close-icon" src={loginClose} alt="" onClick={this.close}/>
					</>
				}
			</div>
		</div>
	}
}

export default ChangePassWordComponent;
